import React from 'react';
import { Marker } from 'react-leaflet';
import { getMarkerEventHandlers } from './functions/events/getMarkerEventHandlers';
import { useSelector } from 'react-redux';
import { markerCoordinatesState, markersInfoState } from '../../../../app/redux/retrievers/retrievers';
import MarkerPopup from './components/MarkerPopup';
import MarkerFixedPopup from './components/MarkerFixedPopup';
import MarkerCluster from './components/MarkerCluster';
import {icon, slopePointIcon} from '../../configs/map-icon.config';
import SingleMarkerFixedPopup from "./components/SingleMarkerFixedPopup";

const MarkerLayer = () => {
    const markersInfo = useSelector(markersInfoState);
    const markerCoords = useSelector(markerCoordinatesState);

    return (
        <>
            {markersInfo && markersInfo.length > 0 ? (
                markersInfo.length <= 50 ? (
                    markersInfo.map((marker) => {
                        return marker.latitude && marker.longitude ? (
                            <div style={{ cursor: 'pointer' }}>
                                {/*----info markers----*/}
                                <Marker
                                    // ref={markerRef}
                                    position={[marker.latitude, marker.longitude]}
                                    icon={marker.color ? icon(marker.color) : icon()}
                                    eventHandlers={getMarkerEventHandlers
                                    (marker.clientMarkerId , marker.latitude , marker.longitude   )
                                    }
                                    autoPan={false}
                                >
                                    {marker.modalBody && <MarkerPopup markerModalBody={marker.modalBody} />}
                                </Marker>
                                {marker.fixedModalBody && <MarkerFixedPopup marker={marker} />}
                            </div>
                        ) : null;
                    })
                ) : (
                    /*marker cluster component used for large data*/
                    <MarkerCluster />
                )
            ) : null}
            {/*----single marker----*/}
            {markerCoords.lat !== 0 && markerCoords.lng !== 0 && (
                <div>
                    <Marker position={[markerCoords.lat, markerCoords.lng]} autoPan={false} icon={icon(markerCoords?.color)}></Marker>
                    {markerCoords.fixedModalBody && <SingleMarkerFixedPopup marker={markerCoords} />}
                </div>
            )}
        </>
    );
};

export default MarkerLayer;
